import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import {
  SortConfigSelected,
  UserSettingContent,
} from '../interfaces/UsuarioVistaModulos'

import { UsuarioVistaModulo } from '@/core/odata/interfaces/MtPerseveranceBackendApiRepositoriesModel'

export interface ItemSetting {
  id: number
  name: string
  configuration: UserSettingContent
  data: UsuarioVistaModulo
  isSelected: boolean
}

export interface ColumnShowed {
  id: number
  title: string
}

interface PageConfigState {
  columnsShowed: ColumnShowed[]
  columnsIdShowed: number[]
  stateIdSelected: number
  sortConfigSelected: SortConfigSelected
  isNecessaryReset: boolean
  settingIdSelected: number
  settingsList: ItemSetting[]
}

const initialState: PageConfigState = {
  columnsShowed: [],
  columnsIdShowed: [],
  stateIdSelected: 0,
  sortConfigSelected: { sortBy: '', sortOrder: '' },
  isNecessaryReset: false,
  settingIdSelected: 0,
  settingsList: [],
}

const pageConfigSlice = createSlice({
  name: 'pageConfig',
  initialState,
  reducers: {
    setColumnsShowed(state, action: PayloadAction<{ value: ColumnShowed[] }>) {
      state.columnsShowed = action.payload.value
    },
    setOneColumnShowed(state, action: PayloadAction<{ value: ColumnShowed }>) {
      const { id, title } = action.payload.value

      const existingItem = state.columnsShowed.find((item) => item.id === id)

      if (!existingItem) {
        state.columnsShowed.push({ id, title })
      } else {
        state.columnsShowed = state.columnsShowed.filter(
          (item) => item.id !== id,
        )
      }
    },
    setStateIdSelected(state, action: PayloadAction<{ value: number }>) {
      state.stateIdSelected = action.payload.value
    },
    setSortConfigSelected(
      state,
      action: PayloadAction<{ value: SortConfigSelected }>,
    ) {
      state.sortConfigSelected = action.payload.value
    },
    setColumnsIdShowed(state, action: PayloadAction<{ value: number[] }>) {
      state.columnsIdShowed = action.payload.value
    },
    setIsNecessaryReset(state, action: PayloadAction<{ value: boolean }>) {
      state.isNecessaryReset = action.payload.value
    },
    setSettingIdSelected(state, action: PayloadAction<{ value: number }>) {
      state.settingIdSelected = action.payload.value
    },
    setSettingsList(state, action: PayloadAction<{ value: ItemSetting[] }>) {
      state.settingsList = action.payload.value
    },
    updateSettingSelection(
      state,
      action: PayloadAction<{ selectedId: number }>,
    ) {
      state.settingsList = state.settingsList.map((setting) => ({
        ...setting,
        isSelected: setting.id === action.payload.selectedId,
      }))
    },
  },
})

export const {
  setOneColumnShowed,
  setColumnsShowed,
  setStateIdSelected,
  setSortConfigSelected,
  setColumnsIdShowed,
  setIsNecessaryReset,
  setSettingIdSelected,
  setSettingsList,
  updateSettingSelection,
} = pageConfigSlice.actions

const PageConfigReducer = pageConfigSlice.reducer

export default PageConfigReducer
